function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var StorefrontViewTemplate = require('./storefront-view.template');
var Teasers = require('./teasers');
var EmptyPanel = require('./empty-panel');
var ListingsTableTemplate = require('./listings-table.template');
var CatalogFooterTemplate = require('./catalog-footer.template');
var _require = require('./browse-listings'),
  loadListingsPage = _require.loadListingsPage;
var _require2 = require('../categories'),
  DEFAULT_PAGE_SIZE = _require2.DEFAULT_PAGE_SIZE,
  MAX_PAGE_SIZE = _require2.MAX_PAGE_SIZE;
var _require3 = require('./listing-approval'),
  submitListingForApproval = _require3.submitListingForApproval,
  markStoreWeb3Active = _require3.markStoreWeb3Active;
var StorefrontView = /*#__PURE__*/function () {
  function StorefrontView(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var callbacks = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, StorefrontView);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.onSell = callbacks.onSell;
    this.onViewChange = callbacks.onViewChange;
    this.publicKey = '';
    /** @type {import('../summary')[]} */
    this.activeSummaries = [];
    this.inventoryLoaded = false;
    this.loading = false;
    this.loadToken = 0;
    this.page = 1;
    this.page_size = DEFAULT_PAGE_SIZE;
    this.pagination = null;
    this.successArmed = false;
    this.successVisible = false;
    this.successDismissed = false;
    this.teasers = new Teasers(app, mod, '');
    this.empty = new EmptyPanel(app, mod, {
      title: 'No listings yet',
      body: 'Items you put up for sale will appear here.',
      actionLabel: 'Add New Listing',
      onAction: function onAction() {
        var _this$onSell;
        return (_this$onSell = _this.onSell) === null || _this$onSell === void 0 ? void 0 : _this$onSell.call(_this);
      }
    });
    /** @type {'public' | 'admin' | 'admin-denied'} */
    this.viewMode = 'public';
    /** @type {'home' | 'active'} Admin content section when viewMode is admin */
    this.adminSection = 'home';
    this.category = '';

    // Progress overlay complete → refresh inventory from warehouse (no local injection).
    this.app.connection.on('store-listing-lifecycle', function (entry) {
      if (!_this.publicKey || (entry === null || entry === void 0 ? void 0 : entry.phase) !== 'complete') {
        return;
      }
      if (_this.successArmed && !_this.successDismissed && _this.isAdminHome()) {
        _this.successVisible = true;
        _this.renderSuccessBanner();
      }
      if (_this.isOwnStorefront() || _this.viewMode === 'public') {
        _this.reloadInventory().then(function () {
          var _this$mod$main;
          var manager = (_this$mod$main = _this.mod.main) === null || _this$mod$main === void 0 ? void 0 : _this$mod$main.manager;
          if ((manager === null || manager === void 0 ? void 0 : manager.activePanel) === 'sales') {
            manager.sales.show();
          }
        });
      }
    });
  }
  return _createClass(StorefrontView, [{
    key: "armSuccessBanner",
    value: function armSuccessBanner() {
      this.successArmed = true;
      this.successDismissed = false;
      this.successVisible = false;
    }
  }, {
    key: "clearSuccessBanner",
    value: function clearSuccessBanner() {
      this.successVisible = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$app$keychain, _this$app$keychain$re, _this$mod$returnStore, _this$mod;
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!this.container) {
        return;
      }
      if (this.viewMode === 'admin-denied') {
        this.app.browser.replaceElementContentBySelector(StorefrontViewTemplate({
          adminDenied: true
        }), this.container);
        return;
      }
      var isDashboard = this.isAdminMode();
      var rawTitle = ((_this$app$keychain = this.app.keychain) === null || _this$app$keychain === void 0 || (_this$app$keychain$re = _this$app$keychain.returnUsername) === null || _this$app$keychain$re === void 0 ? void 0 : _this$app$keychain$re.call(_this$app$keychain, this.publicKey)) || 'Store';
      var shareUrl = this.publicKey ? ((_this$mod$returnStore = (_this$mod = this.mod).returnStorefrontUrl) === null || _this$mod$returnStore === void 0 ? void 0 : _this$mod$returnStore.call(_this$mod, this.publicKey)) || '' : '';
      this.app.browser.replaceElementContentBySelector(StorefrontViewTemplate({
        title: this.escapeHtml(rawTitle),
        description: '',
        shareUrl: shareUrl,
        loading: !!this.publicKey && this.loading && (this.viewMode === 'public' || this.isAdminActive()),
        isDashboard: isDashboard,
        adminSection: this.adminSection,
        showSuccess: this.isAdminHome() && this.successVisible
      }), this.container);
      this.teasers.container = "".concat(this.container, " .teasers");
      this.attachHeaderEvents(shareUrl);
      if (!this.publicKey) {
        return;
      }
      if (this.isAdminHome()) {
        return;
      }
      if (this.loading) {
        return;
      }
      this.renderResults();
    }
  }, {
    key: "renderSuccessBanner",
    value: function renderSuccessBanner() {
      var root = document.querySelector(this.container);
      if (!root || !this.isAdminHome()) {
        return;
      }
      var banner = root.querySelector('[data-listing-success]');
      if (this.successVisible && !banner) {
        this.render();
        return;
      }
      if (!this.successVisible && banner) {
        banner.remove();
      }
    }
  }, {
    key: "attachHeaderEvents",
    value: function attachHeaderEvents() {
      var _root$querySelector,
        _this2 = this,
        _root$querySelector2;
      var shareUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var copyBtn = root.querySelector('[data-action="copy-url"]');
      if (copyBtn) {
        copyBtn.onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            var urlEl, raw, _navigator$clipboard, input, _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  e.preventDefault();
                  urlEl = root.querySelector('[data-storefront-url]');
                  raw = ((urlEl === null || urlEl === void 0 ? void 0 : urlEl.getAttribute('href')) || (urlEl === null || urlEl === void 0 ? void 0 : urlEl.textContent) || shareUrl || '').trim();
                  if (raw) {
                    _context.n = 1;
                    break;
                  }
                  return _context.a(2);
                case 1:
                  _context.p = 1;
                  if (!((_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText)) {
                    _context.n = 3;
                    break;
                  }
                  _context.n = 2;
                  return navigator.clipboard.writeText(raw);
                case 2:
                  _context.n = 4;
                  break;
                case 3:
                  input = document.createElement('input');
                  input.value = raw;
                  document.body.appendChild(input);
                  input.select();
                  document.execCommand('copy');
                  input.remove();
                case 4:
                  if (typeof siteMessage === 'function') {
                    siteMessage('Storefront URL copied', 1500);
                  }
                  _context.n = 6;
                  break;
                case 5:
                  _context.p = 5;
                  _t = _context.v;
                  console.warn('Store: copy storefront URL failed', (_t === null || _t === void 0 ? void 0 : _t.message) || _t);
                case 6:
                  return _context.a(2);
              }
            }, _callee, null, [[1, 5]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }
      (_root$querySelector = root.querySelector('[data-action="list-item"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function (e) {
        var _this2$onSell;
        e.preventDefault();
        (_this2$onSell = _this2.onSell) === null || _this2$onSell === void 0 || _this2$onSell.call(_this2);
      });
      (_root$querySelector2 = root.querySelector('[data-action="dismiss-success"]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('click', function (e) {
        var _root$querySelector3;
        e.preventDefault();
        _this2.successVisible = false;
        _this2.successDismissed = true;
        _this2.successArmed = false;
        (_root$querySelector3 = root.querySelector('[data-listing-success]')) === null || _root$querySelector3 === void 0 || _root$querySelector3.remove();
      });
    }

    /**
     * Show a creator storefront or admin view for the given public key.
     * Active listings via load-listings (same API as marketplace browse).
     * @param {string} publicKey
     * @param {{ viewMode?: 'public' | 'admin' | 'admin-denied', adminSection?: 'home' | 'active' }} [opts]
     */
  }, {
    key: "show",
    value: function () {
      var _show = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var publicKey,
          _ref2,
          _ref2$viewMode,
          viewMode,
          _ref2$adminSection,
          adminSection,
          _ref2$category,
          category,
          nextKey,
          nextViewMode,
          nextSection,
          nextCategory,
          reuseAdminData,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              publicKey = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              _ref2 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, _ref2$viewMode = _ref2.viewMode, viewMode = _ref2$viewMode === void 0 ? 'public' : _ref2$viewMode, _ref2$adminSection = _ref2.adminSection, adminSection = _ref2$adminSection === void 0 ? 'home' : _ref2$adminSection, _ref2$category = _ref2.category, category = _ref2$category === void 0 ? '' : _ref2$category;
              nextKey = String(publicKey || '').trim();
              if (nextKey) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              nextViewMode = viewMode === 'admin' || viewMode === 'admin-denied' ? viewMode : 'public';
              nextSection = adminSection === 'active' ? 'active' : 'home';
              nextCategory = String(category || '');
              reuseAdminData = this.publicKey === nextKey && this.viewMode === 'admin' && nextViewMode === 'admin' && this.inventoryLoaded && !this.loading && this.category === nextCategory;
              this.publicKey = nextKey;
              this.viewMode = nextViewMode;
              this.adminSection = nextSection;
              this.category = nextCategory;
              if (!(this.viewMode === 'admin-denied')) {
                _context2.n = 2;
                break;
              }
              this.loading = false;
              this.render();
              return _context2.a(2);
            case 2:
              if (!(reuseAdminData && nextSection === 'home')) {
                _context2.n = 3;
                break;
              }
              this.render();
              return _context2.a(2);
            case 3:
              if (!(nextSection === 'active')) {
                _context2.n = 5;
                break;
              }
              this.page = 1;
              this.pagination = null;
              this.inventoryLoaded = false;
              _context2.n = 4;
              return this.reloadInventory();
            case 4:
              return _context2.a(2);
            case 5:
              this.inventoryLoaded = false;
              _context2.n = 6;
              return this.reloadInventory();
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function show() {
        return _show.apply(this, arguments);
      }
      return show;
    }()
  }, {
    key: "reloadInventory",
    value: function () {
      var _reloadInventory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var token, result, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (this.publicKey) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (!this.isAdminActive()) {
                _context3.n = 3;
                break;
              }
              _context3.n = 2;
              return this.loadAdminPage({
                page: this.page || 1
              });
            case 2:
              return _context3.a(2);
            case 3:
              this.loading = true;
              token = ++this.loadToken;
              this.render();
              _context3.p = 4;
              _context3.n = 5;
              return loadListingsPage(this.app, this.mod, {
                public_key: this.publicKey,
                category: this.category || '',
                offset: 0,
                page_size: MAX_PAGE_SIZE
              });
            case 5:
              result = _context3.v;
              if (!(token !== this.loadToken)) {
                _context3.n = 6;
                break;
              }
              return _context3.a(2);
            case 6:
              this.activeSummaries = result.listings || [];
              this.inventoryLoaded = true;
              _context3.n = 9;
              break;
            case 7:
              _context3.p = 7;
              _t2 = _context3.v;
              console.warn('Store: load-listings (storefront) failed', (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || _t2);
              if (!(token !== this.loadToken)) {
                _context3.n = 8;
                break;
              }
              return _context3.a(2);
            case 8:
              this.activeSummaries = [];
              this.inventoryLoaded = true;
            case 9:
              if (!(token !== this.loadToken)) {
                _context3.n = 10;
                break;
              }
              return _context3.a(2);
            case 10:
              this.loading = false;
              this.render();
            case 11:
              return _context3.a(2);
          }
        }, _callee3, this, [[4, 7]]);
      }));
      function reloadInventory() {
        return _reloadInventory.apply(this, arguments);
      }
      return reloadInventory;
    }()
  }, {
    key: "loadAdminPage",
    value: function () {
      var _loadAdminPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _ref3,
          _ref3$page,
          page,
          next_page,
          offset,
          token,
          _this$pagination,
          result,
          _args4 = arguments,
          _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _ref3 = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, _ref3$page = _ref3.page, page = _ref3$page === void 0 ? this.page : _ref3$page;
              if (this.publicKey) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              next_page = Math.max(1, Number(page) || 1);
              offset = (next_page - 1) * this.page_size;
              this.page = next_page;
              this.loading = true;
              token = ++this.loadToken;
              this.render();
              _context4.p = 2;
              _context4.n = 3;
              return loadListingsPage(this.app, this.mod, {
                public_key: this.publicKey,
                category: this.category || '',
                offset: offset,
                page_size: this.page_size,
                status: 'active'
              });
            case 3:
              result = _context4.v;
              if (!(token !== this.loadToken)) {
                _context4.n = 4;
                break;
              }
              return _context4.a(2);
            case 4:
              this.activeSummaries = result.listings || [];
              this.noteWeb3Listings(this.activeSummaries);
              this.pagination = result.pagination || null;
              this.page = ((_this$pagination = this.pagination) === null || _this$pagination === void 0 ? void 0 : _this$pagination.page) || this.page;
              this.inventoryLoaded = true;
              _context4.n = 7;
              break;
            case 5:
              _context4.p = 5;
              _t3 = _context4.v;
              console.warn('Store: load-listings (admin active) failed', (_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || _t3);
              if (!(token !== this.loadToken)) {
                _context4.n = 6;
                break;
              }
              return _context4.a(2);
            case 6:
              this.activeSummaries = [];
              this.pagination = {
                offset: 0,
                page: 1,
                page_size: this.page_size,
                total: 0,
                total_pages: 0,
                has_next: false,
                has_previous: false
              };
              this.inventoryLoaded = true;
            case 7:
              if (!(token !== this.loadToken)) {
                _context4.n = 8;
                break;
              }
              return _context4.a(2);
            case 8:
              this.loading = false;
              this.render();
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 5]]);
      }));
      function loadAdminPage() {
        return _loadAdminPage.apply(this, arguments);
      }
      return loadAdminPage;
    }()
  }, {
    key: "isOwnStorefront",
    value: function isOwnStorefront() {
      var walletKey = this.mod.publicKey || '';
      return !!this.publicKey && !!walletKey && this.publicKey === walletKey;
    }
  }, {
    key: "isAdminMode",
    value: function isAdminMode() {
      return this.viewMode === 'admin' && this.isOwnStorefront();
    }
  }, {
    key: "isAdminHome",
    value: function isAdminHome() {
      return this.isAdminMode() && this.adminSection !== 'active';
    }
  }, {
    key: "isAdminActive",
    value: function isAdminActive() {
      return this.isAdminMode() && this.adminSection === 'active';
    }
  }, {
    key: "noteWeb3Listings",
    value: function noteWeb3Listings() {
      var _this$mod$main2;
      var listings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!this.isOwnStorefront()) {
        return;
      }
      var hasWeb3 = listings.some(function (summary) {
        var ticker = String((summary === null || summary === void 0 ? void 0 : summary.web3_ticker) || '').trim().toUpperCase();
        return ticker !== '' && ticker !== 'SAITO';
      });
      if (!hasWeb3 || !markStoreWeb3Active(this.app)) {
        return;
      }
      if (((_this$mod$main2 = this.mod.main) === null || _this$mod$main2 === void 0 || (_this$mod$main2 = _this$mod$main2.menu) === null || _this$mod$main2 === void 0 ? void 0 : _this$mod$main2.mode) === 'dashboard') {
        this.mod.main.menu.render();
      }
    }
  }, {
    key: "renderResults",
    value: function renderResults() {
      var status = document.querySelector("".concat(this.container, " [data-storefront-status]"));
      if (status) {
        status.hidden = true;
        status.innerHTML = '';
      }
      if (this.isAdminActive()) {
        this.renderAdminTable();
        return;
      }
      var teasersEl = document.querySelector("".concat(this.container, " .teasers"));
      if (!teasersEl) {
        return;
      }
      var visible = this.returnVisibleSummaries();
      if (!visible.length) {
        teasersEl.innerHTML = '';
        var emptyHost = document.createElement('div');
        emptyHost.className = 'storefront-empty';
        teasersEl.appendChild(emptyHost);
        this.empty.title = 'No listings yet';
        this.empty.body = 'This creator has not published any listings yet.';
        this.empty.actionLabel = '';
        this.empty.onAction = null;
        this.empty.render("".concat(this.container, " .storefront-empty"));
        return;
      }
      this.teasers.render("".concat(this.container, " .teasers"), visible);
    }
  }, {
    key: "renderAdminTable",
    value: function renderAdminTable() {
      var _this$pagination$tota,
        _this$pagination2,
        _this3 = this;
      var host = document.querySelector("".concat(this.container, " [data-listings-table]"));
      var footer = document.querySelector("".concat(this.container, " [data-catalog-footer]"));
      if (!host) {
        return;
      }
      var listings = this.activeSummaries || [];
      var total = Number((_this$pagination$tota = (_this$pagination2 = this.pagination) === null || _this$pagination2 === void 0 ? void 0 : _this$pagination2.total) !== null && _this$pagination$tota !== void 0 ? _this$pagination$tota : listings.length);
      if (!total) {
        host.innerHTML = '<div class="storefront-empty"></div>';
        if (footer) {
          footer.hidden = true;
          footer.innerHTML = '';
        }
        this.empty.title = 'No active listings.';
        this.empty.body = '';
        this.empty.actionLabel = '+ Add New Listing';
        this.empty.onAction = function () {
          var _this3$onSell;
          return (_this3$onSell = _this3.onSell) === null || _this3$onSell === void 0 ? void 0 : _this3$onSell.call(_this3);
        };
        this.empty.render("".concat(this.container, " .storefront-empty"));
        return;
      }
      host.innerHTML = ListingsTableTemplate({
        listings: listings,
        caption: 'Listings'
      });
      host.querySelectorAll('.listings-table tbody tr[data-signature]').forEach(function (row) {
        row.classList.add('is-clickable');
        row.addEventListener('click', function (e) {
          e.preventDefault();
          var signature = row.getAttribute('data-signature') || '';
          if (!signature) {
            return;
          }
          var summary = (_this3.activeSummaries || []).find(function (item) {
            return String(item.listing_signature || '') === signature;
          });
          if (!summary) {
            return;
          }
          if (!_this3.mod.delist_overlay) {
            var DelistOverlay = require('./overlays/delist-overlay');
            _this3.mod.delist_overlay = new DelistOverlay(_this3.app, _this3.mod);
          }
          _this3.mod.delist_overlay.open(summary);
        });
        var submitBtn = row.querySelector('[data-action="submit-main-store"]');
        submitBtn === null || submitBtn === void 0 || submitBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var signature = row.getAttribute('data-signature') || '';
          if (!signature || submitBtn.disabled) {
            return;
          }
          submitBtn.disabled = true;
          submitListingForApproval(_this3.app, _this3.mod, signature)["catch"](function (err) {
            console.warn('Store: submit-listing failed', (err === null || err === void 0 ? void 0 : err.message) || err);
            submitBtn.disabled = false;
            if (typeof siteMessage === 'function') {
              siteMessage((err === null || err === void 0 ? void 0 : err.message) || 'Unable to submit listing for Store approval.', 4000);
            }
          });
        });
      });
      if (footer) {
        footer.hidden = false;
        footer.innerHTML = CatalogFooterTemplate({
          pagination: this.pagination,
          empty: false
        });
        CatalogFooterTemplate.attachCatalogFooterEvents(footer, {
          page: this.page,
          pagination: this.pagination,
          onPage: function onPage(page) {
            return _this3.loadAdminPage({
              page: page
            });
          }
        });
      }
    }
  }, {
    key: "returnVisibleSummaries",
    value: function returnVisibleSummaries() {
      return this.filterHiddenListings(this.activeSummaries);
    }
  }, {
    key: "filterHiddenListings",
    value: function filterHiddenListings() {
      var summaries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var lifecycle = this.mod.purchase_lifecycle;
      if (!(lifecycle !== null && lifecycle !== void 0 && lifecycle.isListingHidden)) {
        return summaries;
      }
      return summaries.filter(function (summary) {
        return !lifecycle.isListingHidden(summary);
      });
    }
  }, {
    key: "escapeHtml",
    value: function escapeHtml() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
  }]);
}();
module.exports = StorefrontView;